import { useEffect } from "react";

const SocialIntentsChat = () => {

  let appId = process.env.REACT_APP_CLIENTID;

  useEffect(() => {
    const script = document.createElement('script');

    if (appId === "zebratechnologies") {
      script.src = "//www.socialintents.com/api/chat/socialintents.1.4.js#2c9faa3586d8a18a0186da96575600c9";
    }
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Optional: Cleanup the script when the component unmounts
      document.body.removeChild(script);
    };
  }, []);
  return null; // This component doesn't render any UI itself
};

export default SocialIntentsChat;